export function displayAgentName(agentId: string): string {
  const trimmed = agentId.trim();
  if (!trimmed) return agentId;
  const idx = trimmed.lastIndexOf(':');
  if (idx === -1 || idx === trimmed.length - 1) return trimmed;
  return trimmed.slice(idx + 1);
}

export function displayPublisher(agentId: string): string {
  const trimmed = agentId.trim();
  const idx = trimmed.lastIndexOf(':');
  const publisher = idx === -1 ? trimmed : trimmed.slice(0, idx);
  if (publisher.length <= 18) return publisher;
  return `${publisher.slice(0, 8)}...${publisher.slice(-5)}`;
}
